var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 22,
    viewBox: "0 0 124 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4_1",
    clipPath: "url(#clip0_202_1816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7956 0.0316582C16.7658 0.0316582 21.6224 4.92731 21.6224 10.9846C21.6224 13.6836 20.6631 16.1627 19.0549 18.0776C18.8693 18.2976 18.6532 18.5168 18.4364 18.7368C16.4874 20.745 13.7967 21.9692 10.8268 21.9692H0V0L10.7956 0.0316582ZM3.83562 18.0768H10.7956C14.6312 18.0768 17.7555 14.9069 17.7555 11.0154C17.7555 7.1239 14.6312 3.95403 10.7956 3.95403H3.83562V18.0768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.448 21.9683H40.1172L38.1378 18.0452L33.4052 8.63051L28.6727 18.0452L26.6933 21.9683H22.3624L24.3418 18.0452L33.4052 0L42.4686 18.0452L44.448 21.9683Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.5208 14.7187C57.84 13.5887 56.6342 12.8354 55.2421 12.8354H51.3752V21.9993H47.5084V0.0317383H61.1803C62.7885 0.0317383 64.2423 0.690878 65.2944 1.75833C66.3465 2.85662 66.9954 4.33157 66.9954 5.96318C66.9954 8.3481 65.6032 11.3613 63.5926 12.3029C63.0669 12.5538 62.5101 12.7104 61.922 12.7737L64.2327 17.2026L66.9954 22.0001H62.6645L60.2322 17.852M61.1811 8.91308C61.4596 8.91308 61.738 8.85057 61.9852 8.72475C62.6965 8.4106 63.1605 7.2774 63.1605 6.49325C63.1605 5.77161 62.7893 4.73907 62.5733 4.51908C62.3261 4.26825 61.862 3.95411 61.1811 3.95411H51.3752V8.94392L61.1811 8.91226V8.91308Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M92.2045 0L90.2251 3.92318L81.1617 21.9683L72.0983 3.92318L70.1189 0H74.4498L76.4292 3.92318L81.1617 13.3378L85.8942 3.92318L87.8736 0H92.2037H92.2045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M95.3264 21.9683V0H99.1932V21.9683H95.3264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M120.134 6.08811V5.96229C120.134 4.864 119.237 3.95403 118.155 3.95403H109.37C108.287 3.95403 107.39 4.864 107.39 5.96229V6.08811C107.39 7.18641 108.287 8.09638 109.37 8.09638H117.165C119.175 8.09638 120.969 8.97469 122.207 10.3563C122.3 10.4504 122.361 10.5446 122.454 10.6388C123.413 11.8312 124.001 13.3687 124.001 15.032C124.001 18.861 120.939 21.9675 117.165 21.9675H110.39C106.616 21.9675 103.555 18.861 103.555 15.032H107.421C107.421 16.6952 108.751 18.0444 110.39 18.0444H117.165C118.804 18.0444 120.165 16.6952 120.165 15.032C120.165 13.3687 118.804 12.0196 117.165 12.0196H109.37C107.792 12.0196 106.369 11.3921 105.317 10.3563C105.039 10.0738 104.791 9.75965 104.575 9.41466C103.925 8.47303 103.554 7.31223 103.554 6.05645V5.93144C103.554 2.6674 106.152 0 109.369 0H118.154C121.371 0 124 2.6674 124 5.93144V6.05645L120.133 6.08811H120.134Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_1816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3eab3969bbf7a4b62d16b3d92f4d8023.svg";
export { ForwardRef as ReactComponent };